import React from "react";
import { Link } from "react-router-dom";
import { teamMembers, partners } from "../mock";
import { blogPosts } from "../blogData";
import Footer from "../components/heider/Footer";
import useReveal from "../hooks/useReveal";

const mainNav = [
  { label: "Home", to: "/" },
  { label: "Buy with Capital Corner", to: "/buy" },
  { label: "Sell with Capital Corner", to: "/sell" },
  { label: "Broker Opens", to: "/broker-opens" },
  { label: "Media", to: "/media" },
  { label: "Meet the Team", to: "/team" },
  { label: "Become an Agent", to: "/join" },
  { label: "Leadership", to: "/leadership" },
  { label: "Trusted Partners", to: "/partners" },
  { label: "Developers", to: "/developers" },
  { label: "The Journal (Blog)", to: "/blog" },
  { label: "Active Portfolio", to: "/#portfolio" },
  { label: "Sales Portfolio", to: "/#sales" },
  { label: "Recently Sold", to: "/#recent-sold" },
  { label: "Reach & Media", to: "/#reach" },
  { label: "Testimonials", to: "/#testimonials" },
  { label: "Contact", to: "/#contact" },
];

const Column = ({ title, children }) => (
  <div className="reveal">
    <h2 className="font-serif-display text-2xl md:text-3xl font-light text-[#1a1a1a] mb-6 pb-3 border-b border-black/10">{title}</h2>
    <ul className="space-y-3">{children}</ul>
  </div>
);

const Sitemap = () => {
  useReveal();
  const agents = teamMembers;
  const support = partners.map((p) => ({ slug: p.slug, name: p.name, role: p.tag }));

  return (
    <div className="page-in">
      <section className="pt-40 pb-16 md:pt-48 md:pb-20 bg-[#0d0d0d] text-white">
        <div className="max-w-[1300px] mx-auto px-6 md:px-10">
          <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-5">Explore the Site</p>
          <h1 className="font-serif-display text-5xl md:text-7xl font-light">Sitemap</h1>
        </div>
      </section>

      <section className="bg-[#f3f1ec] py-20 md:py-28">
        <div className="max-w-[1300px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-3 gap-14 lg:gap-20">
          <Column title="Main Navigation">
            {mainNav.map((l) => (
              <li key={l.label}>
                <Link to={l.to} onClick={() => window.scrollTo({ top: 0 })} data-testid={`sitemap-nav-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`} className="text-[14px] text-neutral-700 hover:text-[#b4936a] transition-colors">{l.label}</Link>
              </li>
            ))}
          </Column>

          <Column title="Agents & Support Staff">
            {agents.map((m) => (
              <li key={m.slug}>
                <Link to={`/team/${m.slug}`} onClick={() => window.scrollTo({ top: 0 })} data-testid={`sitemap-agent-${m.slug}`} className="text-[14px] text-neutral-700 hover:text-[#b4936a] transition-colors">{m.name} <span className="text-neutral-400 text-[12px]">&middot; {m.role}</span></Link>
              </li>
            ))}
            {support.map((m) => (
              <li key={m.slug} className="pt-2">
                <Link to="/partners" onClick={() => window.scrollTo({ top: 0 })} data-testid={`sitemap-partner-${m.slug}`} className="text-[14px] text-neutral-700 hover:text-[#b4936a] transition-colors">{m.name} <span className="text-neutral-400 text-[12px]">&middot; {m.role}</span></Link>
              </li>
            ))}
          </Column>

          <Column title="Blog Articles">
            {blogPosts.map((p) => (
              <li key={p.slug}>
                <Link to={`/blog/${p.slug}`} onClick={() => window.scrollTo({ top: 0 })} data-testid={`sitemap-blog-${p.slug}`} className="text-[14px] text-neutral-700 hover:text-[#b4936a] transition-colors">{p.title}</Link>
              </li>
            ))}
            <li className="pt-2"><Link to="/blog" onClick={() => window.scrollTo({ top: 0 })} className="text-[11px] tracking-luxe uppercase text-[#b4936a] border-b border-[#b4936a] pb-1">View All Articles</Link></li>
          </Column>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Sitemap;
